module.exports = __webpack_public_path__ + "media/assets/icons/facebookIconGray-f49159a859d72d19a4d2acf738902691.png";